import { useContext } from "react";
import { renderRoutes } from "react-router-config";
import AuthContext from "src/context/AuthContext";
import authRoutesAdmin from "./authRoutesAdmin";
import authRoutesAdminSistema from "./authRoutesAdminSistema";
import authRoutesDueno from "./authRoutesDueno";
import authRoutesOperario from "./authRoutesOperario";
import authRoutesVendedor from "./authRoutesVendedor";
import publicRoutes from "./publicRoutes";

const navItemXPerfil = {
  Vendedor: authRoutesVendedor,
  Dueño: authRoutesDueno,
  Administrador: authRoutesAdmin,
  "Administrador de sistema": authRoutesAdminSistema,
  Operario: authRoutesOperario,
};

export default function HandleRoutes() {
  const authContextConsumer = useContext(AuthContext);
  const { isAuth, handleLogout } = authContextConsumer;

  if (isAuth) {
    const { perfil } = JSON.parse(localStorage.getItem("user_settings"));
    const authRoutes = navItemXPerfil[perfil];
    if (authRoutes) {
      return renderRoutes(authRoutes);
    } else {
      localStorage.clear();
      window.location.reload();
    }
  } else {
    return renderRoutes(publicRoutes);
  }
}
